import { StoreTeam } from "@coworker/types/lib/storeteam";
import FixaTable, {
  FixaTableBody,
  FixaTableHeader,
} from "../../../shared/wrappers/FixaTable/FixaTable";
import SkeletonTableRows from "./TableSkeleton";
import { Trans } from "@coworker/locales";
import styled from "styled-components";
import ChevronRightIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ChevronRightIconPath";
import FixaSSRIcon from "../../../shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import NoTableData from "./NoTableData";

const StyledTableRow = styled.tr`
  cursor: pointer;
  &:hover {
    outline: 1px solid var(--blue-medium);
  }
`;

const StyledTableColumn = styled.td`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface TeamsTableProps {
  teams: StoreTeam[];
  isLoading: boolean;
  handleTeamsRowClick: (teamId: string) => void;
  resetFilters: () => void;
}

const TeamsTable = ({
  teams,
  isLoading,
  handleTeamsRowClick,
  resetFilters,
}: TeamsTableProps) =>
  !teams?.length && !isLoading ? (
    <NoTableData
      title="noTeamsString"
      description="noTeamsDescriptionString"
      resetFilters={resetFilters}
    />
  ) : (
    <FixaTable fullWidth>
      <FixaTableHeader>
        <tr>
          <th>
            <Trans>capitalisedTeamNameString</Trans>
          </th>
          <th>
            <Trans>usersString</Trans>
          </th>
          <th>
            <Trans>productQualityTeamString</Trans>
          </th>
        </tr>
      </FixaTableHeader>
      <FixaTableBody>
        {isLoading ? (
          <SkeletonTableRows />
        ) : (
          teams?.map((team) => (
            <StyledTableRow
              key={team.id}
              onClick={() => handleTeamsRowClick(team.id)}
            >
              <td>{team.name}</td>
              <td>{team.user_count}</td>
              <StyledTableColumn>
                {team.is_product_quality ? (
                  <Trans>yesString</Trans>
                ) : (
                  <Trans>noString</Trans>
                )}
                <FixaSSRIcon paths={ChevronRightIconPath} />
              </StyledTableColumn>
            </StyledTableRow>
          ))
        )}
      </FixaTableBody>
    </FixaTable>
  );

export default TeamsTable;
